module.exports = __webpack_public_path__ + "media/assets/images/plan03_label-1bb65673c2770f51b214bb915b2b9e4c.png";